export default function () {
  return [
    {
      title: 'Report',
      htmlBefore: '<i class="material-icons">edit</i>',
      items: [
        {
          title: 'Atricle Analysis',
          to: {
            name: 'blog-overview',
          },
        },
        {
          title: 'Booking Analysis',
          to: {
            name: 'booking-report',
          },
        },
      ]
    }, {
      title: 'Article',
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      items: [{
        title: 'Channel',
        to: {
          name: 'channel',
        },
      },
      {
        title: 'Article',
        to: {
          name: 'article',
        },
      }]
    }, {
      title: 'Booking',
      htmlBefore: '<i class="material-icons">book_online</i>',
      items: [
        {
          title: 'Booking Record',
          to: {
            name: 'booking-record',
          },
        },
        {
          title: 'Pending Approve',
          to: {
            name: 'pending-approval',
          },
        },
        {
          title: 'Booking Time Settings',
          to: {
            name: 'booking-time-slot',
          },
        },]
    },
    {
      title: 'Realtime Indoor Map',
      htmlBefore: '<i class="material-icons">location_on</i>',
      to: {
        name: 'map',
      },
    },
    {
      title: 'User Account',
      htmlBefore: '<i class="material-icons">person</i>',
      items: [{
        title: 'User Profile',
        to: {
          name: 'user-profile-lite',
        },
      },
      {
        title: 'Change Password',
        to: {
          name: 'change-password',
        },
      },]
    }, {
      title: 'Management',
      htmlBefore: '<i class="material-icons">contact_mail</i>',
      items: [{
        title: 'Staff Management',
        to: {
          name: 'staff-management',
        },
      },
      {
        title: 'User Management',
        to: {
          name: 'user-management',
        },
      },]
    },];
}
